import { Box } from '@zillow/constellation-10';
import { boneStyles } from './styles';

import type { BoneTypes } from './styles';

type Props = {
  type?: BoneTypes;
  className?: string;
};

const Bone = ({ type = 'line', className = '' }: Props) => (
  <Box css={boneStyles.raw({ type })} className={className} data-loading={true} />
);

export default Bone;
